import { useFrame, useThree } from '@react-three/fiber';
import { getXRModule } from './xrModule.js';
const { useXR } = getXRModule();
// Modifies the auto-rendered hand model materials to make fingertips semi-transparent.
// In xr v6, hands are auto-rendered. We traverse the scene to find hand meshes.
// TODO: can this just be a hook (since it does not return any JSX)?
export function HandDecorate() {
    const session = useXR(state => state.session);
    const { scene } = useThree();
    useFrame(() => {
        if (!session)
            return;
        // Traverse scene to find hand meshes and modify their material
        scene.traverse((child) => {
            if (child.isMesh && child.material && child.userData?.xpiHand) {
                const mesh = child;
                // eslint-disable-next-line no-param-reassign
                mesh.material.transparent = true;
                // eslint-disable-next-line no-param-reassign
                mesh.material.opacity = 0.5;
            }
        });
    });
    return null;
}
//# sourceMappingURL=HandDecorate.js.map